export const zusWarningKhNoEmployees = 'zus-warning-kh-no-employees';
export const zusWarningNoFormOfAccounting = 'zus-warning-no-form-of-accounting';

export default {
  zusWarningKhNoEmployees,
  zusWarningNoFormOfAccounting,
};
